const routes = [{
  path: '/adStat',
  component: () => import('@/views/ad/index'),
  name: 'ad-stat',
  meta: {
    title: '广告效果'
  }
}, {
  path: '/adCreative',
  component: () => import('@/views/ad/creative'),
  name: 'ad-creative',
  meta: {
    title: '广告管理'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/ad.js